module.exports = __webpack_public_path__ + "img/honor7.4faa0da6.png";